
export class GroupAddingModel {
    id:number;
    groupName?:string;
    location?:string;
    genDate?:Date;
    status?:string;
}
